module.exports = __webpack_public_path__ + "img/bank.afbda88d.svg";